import { Attr, BelongsTo, Model } from "spraypaint"

import ApplicationRecord from "./applicationRecord/applicationRecord"
import type { Organization } from "./organization"

@Model()
export class Department extends ApplicationRecord {
  public static readonly jsonapiType = "departments"

  @BelongsTo("organizations") public organization!: Organization

  @Attr() public readonly name!: string

  @Attr() public readonly dateCreated!: string

  @Attr() public readonly dateUpdated!: string

  @Attr() public readonly organizationId!: number
}
